module.exports = __webpack_public_path__ + "img/plan-2-b11.21a7e54f.png";